import { render, staticRenderFns } from "./Recocell.vue?vue&type=template&id=ca39ac06&"
import script from "./Recocell.vue?vue&type=script&lang=js&"
export * from "./Recocell.vue?vue&type=script&lang=js&"
import style0 from "./Recocell.vue?vue&type=style&index=0&id=ca39ac06&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports